module.exports = __webpack_public_path__ + "img/main-banner.7ce42cd9.png";